import React, { useState } from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import CreateFormulario from "@components/Formulario/Create.jsx";
import GridFormulariosModelos from '@components/Formulario/Grid.jsx';
import { useGenericReducer } from '@hooks/state/useGenericReducer.js';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';
import EditFormularioModal from '@components/Modals/Admin/FormularioEditModal/Index.jsx';

function Formularios() {
  const NomeForm = "Cadastro de Formulários";
  const [selectedRow, setSelectedRow] = useState(null);
  const { state, setData, addItem, updateItem, deleteItem } = useGenericReducer();

  const [visible, setVisible] = useState(false);
  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  return (
    <PageWrapper>
      <div className="row">
        <BreadcrumbComp Param1="Home" Param2="Cadastros & Parâmentros" Param3={NomeForm} />
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6 d-flex align-items-center">
                  <h2 className="mb-0">{NomeForm}</h2>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <CreateFormulario onSave={addItem} />

                <EditFormularioModal
                  visible={visible}
                  selectedRow={selectedRow}
                  onUpdate={updateItem}
                  closeModal={closeModal}
                />

                <GridFormulariosModelos
                  state={state}
                  setData={setData}
                  openModal={openModal}
                  setSelectedRow={setSelectedRow}
                  onDelete={deleteItem}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default Formularios;